// data.service.ts
import { Injectable, TemplateRef, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../_services/app.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Helpers } from '../../../helpers';
import { environment } from '../../../../environments/environment';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CookieService } from 'ngx-cookie-service';
import { PrimaryAppColor } from '../../../shared/config/color-code';
import {
      Http,
      Headers,
      RequestOptions,
      Response,
      JSONPBackend,
} from "@angular/http";
import { TranslateConfigService } from '../../../theme/home/translateConfig.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
const LNG_KEY = "SELECTED_LANGUAGE";


@Injectable()
export class CommonService {
      constructor(private _appService: appService, private translate: TranslateService,
            private toastr: ToastrService, private datePipe: DatePipe, private decryptpipe: DecryptPipe,
            private cookieService: CookieService, private service: TranslateConfigService, private modalService: NgbModal,

      ) { }

      deleteFileId(Id): Promise<any> {
            return new Promise((resolve) => {
                  const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
                  dialogRef.componentInstance.details = {
                        message: this.translate.instant("BOOKINGSCOMPLETED.AreYouSure"),
                        title: 'Confirmation',
                  }
                  dialogRef.componentInstance.close.subscribe((res: any) => {
                        if (res) {
                              Helpers.setLoading(true);
                              this._appService.Delete("Document", "DeleteAttachment", Id).subscribe(response => {
                                    Helpers.setLoading(false);
                                    this.toastr.success("File Deleted Successfully !", 'Success');
                                    resolve(response)
                              }, err => {
                                    Helpers.setLoading(false);
                                    this.toastr.error("An error occured while deleting data !", 'error');
                              });
                        }
                        dialogRef.close();
                  });
            })
      }

      validatePattern = (value, pattern = /[a-z0-9\._%+!$&*=^|~#%'`?{}/\-]+@([a-z0-9\-]+\.){1,}([a-z]{2,16})/): boolean => {
            const regEx = new RegExp(pattern);
            if (!regEx.test(value)) {
                  this.toastr.error('Please Enter Valid Email');
                  return false;
            } else {
                  return true;
            }
      }

      langaugeSettting(): any {
            let language = this.translate.getBrowserLang();
            let value = localStorage.getItem(LNG_KEY);
            if (value === "" || value === null || value === undefined) {
                  this.translate.setDefaultLang(language);
                  return language;
            } else {
                  this.service.setLanguage(value);
                  return value;
            }
      }

      isValidFileType(file: File, allowedTypes = ['image/jpeg', 'image/png']): boolean {
            // Check it's an image (JPEG or PNG)
            // allowedTypes = ['image/jpeg', 'image/png'];
            const fileType = file.type.toLowerCase();
            if (!allowedTypes.includes(fileType)) {
                  this.toastr.error(this.translate.instant("SETTING.ImageOnly"), 'Error');
                  return false;
            }
            return true;
      }

      isValidFileTypeV2(file: File, allowedTypes = ['image/jpeg', 'image/png', 'application/pdf']): boolean {
            // Check it's an image (JPEG or PNG)
            // allowedTypes = ['image/jpeg', 'image/png'];
            const fileType = file.type.toLowerCase();
            if (!allowedTypes.includes(fileType)) {
                  this.toastr.error(this.translate.instant("SETTING.DocOnly"), 'Error');
                  return false;
            }
            return true;
      }

      isValidFileExtension(file: File, allowedTypes = ['image/jpeg', 'image/png']): boolean {
            const exptension = file.name.split('.');
            if (!allowedTypes.includes(exptension[1])) {
                  this.toastr.error(this.translate.instant("SETTING.ImageOnly"), 'Error');
                  return false;
            }
            return true;
      }

      isValidFileName(file: File): boolean {
            var format = /^[a-zA-Z0-9]*\.[a-zA-Z0-9]*$/;
            if (!format.test(file.name)) {
                  this.toastr.error(this.translate.instant("SETTING.InvalidFile"), 'Error');
                  return false;
            }
            return true;
      }

      isFileSizeExceeded(file: File): boolean {
            // Add your file size validation logic here
            const maxSizeInBytes = 1024 * 1024 * environment.maxFileSize; // Convert MB to bytes
            const fileSize = file.size;
            if (fileSize > maxSizeInBytes) {
                  this.toastr.error(this.translate.instant("SETTING.FileSize"), 'Error');
                  return false;
            }
            return true;
      }

      formatSelectedDate(date): string {
            if (!!date) {
                  const newDate = new Date(date);
                  if (isNaN(newDate.getTime())) {
                        return date;
                  }
                  return this.datePipe.transform(newDate, 'dd-MM-yy');
            }
      }

      b64toBlob(b64Data, contentType) {
            contentType = contentType || "";
            let sliceSize = 512;
            var byteCharacters = atob(b64Data);
            var byteArrays = [];
            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                  var slice = byteCharacters.slice(offset, offset + sliceSize);
                  var byteNumbers = new Array(slice.length);
                  for (var i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                  }
                  var byteArray = new Uint8Array(byteNumbers);
                  byteArrays.push(byteArray);
            }
            var blob = new Blob(byteArrays, { type: contentType });
            return blob;
      }

      calculateDaysBetweenDates(date1: any, date2: any): string {
            if (date1 && date2) {
                  date1 = new Date(date1);
                  date2 = new Date(date2);
                  const timeDifference = Math.abs(date2.getTime() - date1.getTime());
                  const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
                  if (date2 >= date1) {
                        // The date is yet to expired
                        return (daysDifference + 1 + ' ' + 'Days');
                  } else {
                        return (daysDifference + ' ' + 'Days');

                  }

            }
      }

      ExportDump(FileContent, divId) {
            var byteNumbers = new Array(FileContent.Content.length);
            for (var i = 0; i < FileContent.Content.length; i++) {
                  byteNumbers[i] = FileContent.Content.charCodeAt(i);
            }
            var blob = this.b64toBlob(
                  FileContent.Content,
                  FileContent.ContentType
            );
            let url = window.URL.createObjectURL(blob);
            $("#" + divId).attr("href", url);
            $("#" + divId).attr("download", FileContent.FileName);
            let element: HTMLElement = document.getElementById(
                  divId
            ) as HTMLElement;
            element.attributes;
            element.click();
      }

      setHeaderAndOptionsForFileUpload(file, fileTypeName = 'file'): any {

            var headers = new Headers();
            let user_access_token = this.decryptpipe.transform(
                  JSON.parse(this.cookieService.get("user_access_token"))
            );
            const token: string = "Bearer " + user_access_token;
            headers.append("Authorization", token);
            let options = new RequestOptions({ headers: headers });
            const formData = new FormData();
            formData.set(fileTypeName, file);
            return { formData, options }
      }

      //For svg color change function
      onSvgLoad(url, id) {
            fetch(url)
                  .then(response => response.text()) // Convert the response to text
                  .then(svgContent => {
                        // Parse the SVG content using the DOMParser
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(svgContent, 'image/svg+xml');

                        // Select an element by its class
                        const circleElement = doc.querySelectorAll('.color');

                        if (circleElement) {
                              // Manipulate the selected element
                              Array.from(circleElement).forEach(element => {
                                    const color = PrimaryAppColor;
                                    element.setAttribute('fill', color);
                              });
                        }

                        const clonedSvg = doc.documentElement.cloneNode(true);

                        // Append the <div> to the "svg-container" element in the HTML
                        const container = document.getElementById(id);
                        if (container) {
                              container.innerHTML = ''; // Clear the container
                              container.appendChild(clonedSvg);
                        }

                  })
                  .catch(error => {
                        console.error('Error fetching SVG:', error);
                  });

      }

      RoleRightsData: any = [];
      public CheckHasRight(RightCode, ScreenCode): Boolean {
            this.RoleRightsData = JSON.parse(localStorage.getItem("rights_assigned"));
            var flag: Boolean = true;
            let UserRole = this.decryptpipe.transform(JSON.parse(this.cookieService.get("SetUserRole")));
            if (UserRole.match("Admin")) {
                  return true;
            }
            this.RoleRightsData.forEach((element) => {
                  if (element.ScreenCode == ScreenCode && element.RightCode == RightCode) {
                        if (element.RoleScreenRightsId == null) {
                              flag = false;
                        }
                  }
            });
            return flag;
      }
}
